import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const CREDIT_CARD: PaymentMethod = {
    id: PAYMENT_METHOD_ID.CreditCard,
    name: 'card',
    tokenRequired: true
};
